/**
 * Helpers para dados estruturados (schema.org) de produtos/planos.
 * O Google exige que todo item @type Product tenha "offers", "review" ou
 * "aggregateRating". Planos sem preço fixo são publicados como @type Service.
 */

export function parseBRLPrice(price: string): string | null {
  const raw = price.replace(/[^\d,.]/g, "").replace(/\.(?=\d{3})/g, "").replace(",", ".");
  const n = Number(raw);
  return raw && !Number.isNaN(n) && n > 0 ? n.toFixed(2) : null;
}

type Base = {
  name: string;
  description: string;
  url: string;
  price: string;
  image?: string;
};

/** Retorna um nó Product com offers válido, ou Service quando não há preço público. */
export function buildProductNode({ name, description, url, price, image }: Base) {
  const value = parseBRLPrice(price);
  const brand = { "@type": "Brand", name: "OP2P" };

  if (!value) {
    return {
      "@type": "Service",
      name,
      description,
      url,
      ...(image ? { image } : {}),
      serviceType: "Agentes de IA e CRM",
      provider: { "@type": "Organization", name: "OP2P", url: "https://op2p.ai" },
      areaServed: "Online",
    };
  }

  return {
    "@type": "Product",
    name,
    description,
    url,
    ...(image ? { image } : {}),
    brand,
    offers: {
      "@type": "Offer",
      price: value,
      priceCurrency: "BRL",
      availability: "https://schema.org/InStock",
      url,
      priceValidUntil: `${new Date().getFullYear() + 1}-12-31`,
      seller: { "@type": "Organization", name: "OP2P", url: "https://op2p.ai" },
    },
  };
}
